<template>
	<div class="home">
		<div class="head">
			<el-breadcrumb separator="/">
			  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			  <el-breadcrumb-item>集团统计</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="search" style="background-color: #fff;">
			<vs-row>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">查询条件：</vs-col>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" class="m-4 p-d flex">
					    <el-date-picker
								style="width:100%"
					            v-model="yearmonth"
								format="yyyy年MM月"
								value-format="yyyy-MM"
								placeholder="选择月份"
					            type="month">
					    </el-date-picker>	
				</vs-col>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
					<vs-button color="primary" type="filled" style="width:60%;margin-right: 20px;"  @click="search">搜索</vs-button>
					<vs-button color="success" type="filled" style="width:80%"  @click="handle_export">导出表格</vs-button>
				</vs-col>
			</vs-row>
		</div>
		<div class="tabs">
			<el-tabs v-model="activeName" @tab-click="handleClick">
			    <el-tab-pane label="数据总览" name="first">
					<div style="display: flex;flex-direction: column;">
						<div class="vx-col w-full   mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">集团汇总平均分：</p>
							<el-table
							  id="table1"
							  :header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
							  border
							  :data="onetable1"
							  style="width: 100%">
							  <el-table-column
							    prop="positionName"
							    label="事业部"
							    width="180">
							  </el-table-column>
							  <el-table-column
							    prop="amount1"
							    label="上月考核分数目标">
								<template slot-scope="scope">
								  <p style="color: red;"><el-input v-model="scope.row.goal" type="number"></el-input></p>
								</template>
							  </el-table-column>
							  <el-table-column
							    prop="averageScoreLastMonth"
							    label="上月实际平均分"
							    width="180">
							  </el-table-column>
							  <el-table-column
							    prop="numberOfPeopleLastMonth"
							    label="上月考核人数"
							    width="180">
							  </el-table-column>
							  <el-table-column
							    prop="result"
							    label="上月完成情况分析">
								<template slot-scope="scope">
								  <p style="color: red;" v-if="scope.row.result>=0">超目标{{scope.row.result}}分</p>
								  <p style="color: green;" v-if="scope.row.result<0">超目标{{scope.row.result}}分</p>
								</template>
							  </el-table-column>
							  <el-table-column
							    prop="averageScoreThisMonth"
							    label="本月实际分数"
							    width="180">
							  </el-table-column>
							  <el-table-column
							    prop="numberOfPeopleThisMonth"
							    label="本月考核人数"
							    width="180">
							  </el-table-column>
							</el-table>
						</div>
					</div>
				</el-tab-pane>
			    <el-tab-pane label="年度对比" name="second">
					<div style="display: flex;flex-direction: column;">
						<div class="vx-col w-full  mb-base">
						<vue-apex-charts type=line height=266 ref="lineone1" :options="analyticsData.revenueComparisonLine.chartOptions" :series="analyticsData.revenueComparisonLine.series" />
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">年度平均分：</p>
							<el-table
							  id="table2"
							  :header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
							  border
							  :data="twotable1"
							  style="width: 100%">
							  <el-table-column
							    prop="deptName"
								align="center"
							    label="事业部"
							    width="180">
							  </el-table-column>
							  <el-table-column
							    v-for="(item,index) in twotable1[0].data"
								:key="index"
							    align="center"
							    :label="item.month">
								<template slot-scope="scope">
								  <p>{{twotable1[scope.$index].data[index].avgScore}}</p>
								</template>
							  </el-table-column>
							</el-table>
						</div>
					</div>
				</el-tab-pane>
			    <el-tab-pane label="各项对比" name="third">
					<div style="display: flex;flex-direction: column;">
						<div class="vx-col w-full  mb-base">
						        <div class="flex">
						            <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>总览平均分柱状图</span></span>
						        </div>
						        <vue-apex-charts type=bar height=277 ref="barone1" :options="analyticsData.clientRetentionBar.chartOptions" :series="analyticsData.clientRetentionBar.series" />
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">四大类各项平均分：</p>
							<el-table
							  id="table3"
							  :header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
							  border
							  :data="thirdtable1"
							  style="width: 100%">
							  <el-table-column
							    type="index"
								align="center"
							    label="序号"
							    width="180">
							  </el-table-column>
							  <el-table-column
							    prop="deptName"
								align="center"
							    label="事业部"
							    width="180">
							  </el-table-column>
							  <el-table-column
							    v-for="(item,index) in thirdtable1[0].data"
							  	:key="index"
							    align="center"
							    prop="positionName"
							    :label="item.dimensionName">
							  	<template slot-scope="scope">
							  		<p>{{thirdtable1[scope.$index].data[index].score}}</p>
							  	</template>
							  </el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base flex" style="align-items: flex-end;justify-content: space-around;">
								<div class="vx-col w-full md:w-2/5  mb-base">
									<div class="flex">
									        <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>顾客至上平均分</span></span>
									</div>
									<vue-apex-charts type=bar height=277 ref="barone2" :options="analyticsData.clientRetentionBar.chartOptions" :series="analyticsData.clientRetentionBar.series" />
								</div>
								<div class="vx-col w-full md:w-2/5  mb-base">
									<div class="flex">
									        <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>团队精神平均分</span></span>
									</div>
									<vue-apex-charts type=bar height=277 ref="barone3" :options="analyticsData.clientRetentionBar.chartOptions" :series="analyticsData.clientRetentionBar.series" />
								</div>
						</div>
						<div class="vx-col w-full  mb-base flex" style="align-items: flex-end;justify-content: space-around;">
								<div class="vx-col w-full md:w-2/5  mb-base">
									<div class="flex">
									        <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>追求卓越平均分</span></span>
									</div>
									<vue-apex-charts type=bar height=277 ref="barone4" :options="analyticsData.clientRetentionBar.chartOptions" :series="analyticsData.clientRetentionBar.series" />
								</div>
								<div class="vx-col w-full md:w-2/5  mb-base">
									<div class="flex">
									        <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>长期坚持艰苦奋斗平均分</span></span>
									</div>
									<vue-apex-charts type=bar height=277 ref="barone5" :options="analyticsData.clientRetentionBar.chartOptions" :series="analyticsData.clientRetentionBar.series" />
								</div>
						</div>
					</div>
				</el-tab-pane>
			  </el-tabs>
		</div>
	</div>
</template>
<script>
	import FileSaver from "file-saver";
	import XLSX from "xlsx";
	
	import analyticsData from './ui-elements/card/analyticsData.js'
	import VueApexCharts from 'vue-apexcharts'
	export default {
	    data() {
	        return {
				analyticsData: analyticsData,
				activeName:"first",
				onetable1:[],
				twotable1:[{data:[]}],
				thirdtable1:[{data:[]}],
				five:[],
				yearmonth:'',   //月份
			}
	    },
		created() {
			this.yearmonth=this.getNowFormatDate();
		},
		mounted() {
			this.getall();
		},
		watch:{
			onetable1:{
				handler(newvalue,oldvalue) {
					this.onetable1.map((item)=>{
						item.result=(item.averageScoreLastMonth-item.goal).toFixed(2);
					})
					
				},
				deep: true
			}
		},
		components: {
		    VueApexCharts,
		},
		methods:{
			// 导出
			handle_export() {
			    var xlsxParam = {
			        raw: true
			    }; //转换成excel时，使用原始的格式，这样导出的时候数字过长不会变成科学计数法
			    let workbook = XLSX.utils.book_new();
				let ws0 = XLSX.utils.table_to_sheet(document.querySelector('#table1'), xlsxParam);
				XLSX.utils.book_append_sheet(workbook, ws0, '集团汇总平均分');
			    let ws1 = XLSX.utils.table_to_sheet(document.querySelector('#table2'), xlsxParam);
			    // 这里可以添加多个sheet页
			    XLSX.utils.book_append_sheet(workbook, ws1, '年度平均分');
			    let ws2 = XLSX.utils.table_to_sheet(document.querySelector('#table3'), xlsxParam);
			    XLSX.utils.book_append_sheet(workbook, ws2, '四大类各项平均分');
			    let wbout = XLSX.write(workbook, {
			        bookType: 'xlsx',
			        bookSST: true,
			        type: 'array'
			    });
			    try {
			        FileSaver.saveAs(
			        new Blob([wbout], {
			            type: 'application/octet-stream;charset=utf-8"'
			        }), '集团统计.xlsx');
			    } catch (e) {
			        if (typeof console !== 'undefined') console.log(e);
			    }
			    return wbout;
			},
			 //定义导出Excel表格事件
			exportExcel() {
			      var xlsxParam = { raw: true };
			      /* 从表生成工作簿对象 */
			      var wb = XLSX.utils.table_to_book(
			        document.querySelector("#outtable"),
			        xlsxParam
			      );
			      /* 获取二进制字符串作为输出 */
			      var wbout = XLSX.write(wb, {
			        bookType: "xlsx",
			        bookSST: true,
			        type: "array",
			      });
			      try {
			        FileSaver.saveAs(
			          //Blob 对象表示一个不可变、原始数据的类文件对象。
			          //Blob 表示的不一定是JavaScript原生格式的数据。
			          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
			          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
			          new Blob([wbout], { type: "application/octet-stream" }),
			          //设置导出文件名称
			          "sheetjs.xlsx"
			        );
			      } catch (e) {
			        if (typeof console !== "undefined") console.log(e, wbout);
			      }
			      return wbout;
			},
			/**
			* 获取上一个月
			* @date 格式为yyyy-mm-dd的日期，如：2014-01
			*/
			getPreMonth(date) {
			            var arr = date.split('-');
			            var year = arr[0]; //获取当前日期的年份
			            var month = arr[1]; //获取当前日期的月份
			            var days = new Date(year, month, 0);
			            days = days.getDate(); //获取当前日期中月的天数
			            var year2 = year;
			            var month2 = parseInt(month) - 1;
			            if (month2 == 0) {
			                year2 = parseInt(year2) - 1;
			                month2 = 12;
			            }
			            if (month2 < 10) {
			                month2 = '0' + month2;
			            }
			            var t2 = year2 + '-' + month2;
			            return t2;
			},
			
			sortBythisMonth(row, index){	//本月排序
				console.log("排序啦",row,index);
				return [row.data[0].avgScore]
			},
			
			TableRowStyle({ row, column, rowIndex, columnIndex }){
				if (columnIndex != 0&&columnIndex != 1&&columnIndex != 23) {
					if(rowIndex%3==0){
						return {color:"red",fontSize: "18px"};
					}else if(rowIndex%3==1){
						return {color:"#5ECDF5",fontSize: "18px"};
					}else if(rowIndex%3==2){
						return {color:"#000000",fontSize:"18px"};
					}
				}else{
					return {color:"#000000",fontSize:"18px"};
				}
			},

			
			getSummaries(param) {   //合计数据处理
			        const { columns, data } = param;
					console.log(columns,data);
			        const sums = [];
			        columns.forEach((column, index) => {
			          if (index === 0) {
			            sums[index] = '合计(平均分)';
			            return;
			          }
					  if(index===1){sums[1]='/';return;}
					  if(index===2){
						  var savg=0;
						  data.forEach(item=>{
							  savg=savg+Number(item.finalScore);
						  })
						  savg=(savg/data.length).toFixed(2);
						  sums[2]=savg;
						  return;
					  }
					  if(index===3){
					  		var navg=0;
					  		data.forEach(item=>{
					  		navg=navg+Number(item.result);
					  		})
							navg=(navg/data.length).toFixed(2);
					  		sums[3]="超目标"+navg+"分";
							return;
					  }
			        });
			        return sums;
			},
			
			handleClick(){
				console.log("切换了",this.activeName);
				if(this.activeName=="first"){this.getall()}
				else if(this.activeName=="second"){this.getsecend()}
				else if(this.activeName=="third"){this.getthird()}
			},
			search(){
				if(this.activeName=="first"){this.getall()}
				else if(this.activeName=="second"){this.getsecend()}
				else if(this.activeName=="third"){this.getthird()}
			},
			getthird(){     
				const that = this;
				this.$api.groupfour({assessTime:that.yearmonth}).then(function (response) {
					if(response.code==0){
						 console.log("各项对比",response);
						 that.thirdtable1=response.data;   //全部
						 var arr=[];
						 var allname=[];
						 var num1=[];var num2=[];var num3=[];var num4=[];
						 for(var i=0;i<response.data.length;i++){
						 		allname.push(response.data[i].deptName);
						 		var num=0;
								num1.push(response.data[i].data[0].score);
								num2.push(response.data[i].data[1].score);
								num3.push(response.data[i].data[2].score);
								num4.push(response.data[i].data[3].score);
						 		response.data[i].data.forEach(item=>{
									num+=Number(item.score);	
						 		})
						 	arr.push(num.toFixed(2));
						 }
						 console.log(111,num1);
						 that.$refs.barone1.updateOptions({
						 		series:[{name:'平均分',data:arr}],
						 		xaxis:{categories:allname}
						 })
						 that.$refs.barone2.updateOptions({
						 		series:[{name:'平均分',data:num1}],
						 		xaxis:{categories:allname}
						 })
						 that.$refs.barone3.updateOptions({
						 		series:[{name:'平均分',data:num2}],
						 		xaxis:{categories:allname}
						 })
						 that.$refs.barone4.updateOptions({
						 		series:[{name:'平均分',data:num3}],
						 		xaxis:{categories:allname}
						 })
						 that.$refs.barone5.updateOptions({
						 		series:[{name:'平均分',data:num4}],
						 		xaxis:{categories:allname}
						 })
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  }) 
			},
			getsecend(){   //年度对比
				const that = this;
				this.$api.groupyear({assessTime:that.yearmonth}).then(function (response) {
					if(response.code==0){
						console.log("年月度",response.data);
						 that.twotable1=response.data;
						 var arr=[];
						 var allname=[];
						 for(var i=0;i<response.data.length;i++){
							 var name=response.data[i].deptName;
							 var num=[];
							 response.data[i].data.forEach(item=>{
								num.push(item.avgScore);	
								if(allname.indexOf(item.month)<0){
									allname.push(item.month);
								}
							 })
							 arr.push({name:name,data:num});
						 }
						 that.$refs.lineone1.updateOptions({
						 		series:arr,
						 		xaxis:{categories:allname}
						 })
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  }) 
			},
			getall(){
				const that = this;
				this.$api.groupsummary({assessTime:that.yearmonth}).then(function (response) {
					if(response.code==0){
						 console.log("总体",response);
						 that.onetable1=response.data.map((item)=>{
							 item.goal=75;
							 item.result=(Number(item.averageScoreLastMonth)-75).toFixed(2);
							 return item;
						 });
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  })
			},
			getNowFormatDate() {
			        var date = new Date();
			        var seperator1 = "-";
			        var year = date.getFullYear();
			        var month = date.getMonth() + 1;
			        var strDate = date.getDate();
			        if (month >= 1 && month <= 9) {
			            month = "0" + month;
			        }
			        if (strDate >= 0 && strDate <= 9) {
			            strDate = "0" + strDate;
			        }
			        var currentdate = year + seperator1 + month ;
					var lastmonth = this.getPreMonth(currentdate)
			        return lastmonth;
			},
			
		}
	}
</script>
<style type="text/css">
	.home .head{
		height: 50px;
		display: flex;
		align-items: center;
		background: #ffffff;
		padding: 20px;
	}
	.home .tabs{
		margin: 20px 30px;
		background: #ffffff;
		padding: 20px;
	}
	
	.home .el-table{
		border: 1px solid #000000 !important;
		border-left: 1px solid #000000 !important;
	}
	.home .el-table td,
	.home .el-table th {
	        border-bottom: 1px solid #000000 !important;
			border-right: 1px solid #000000 !important;
	}
</style>
